// @ts-nocheck

import React, { Component } from 'react';
import Button from 'antd/lib/button';
import styled from 'styled-components';
import moment from 'moment';

import { DatePicker } from '../../../components/ant/DatePicker';
import { Card } from './../../../components';
import { Popconfirm } from './../../../components/ui';
import { getDisabledEqipmentInstallRemoveDate } from './../../../containers/Equipment/lib';

const { Field } = Card;
const PopconfirmTitleWrapper = styled.div``;
const ErrorText = styled.p`
  color: red;
  margin: 5px 0;
`;

const getMomentValue = (value) => value ? moment.utc(value) : value;

const convertDateToString = (value, dateString) => {
  if (value) {
    return moment.utc(dateString, 'DD.MM.YYYY').toISOString();
  }
  return value;
};








const PopconfirmTitle = ({
  onChange,
  dateInstall,
  error,
  disableDate
}) =>
<PopconfirmTitleWrapper>
    <Field label="Дата установки">
      <DatePicker
      format="DD.MM.YYYY"
      value={getMomentValue(dateInstall)}
      onChange={onChange}
      disabledDate={disableDate && getDisabledEqipmentInstallRemoveDate} />

      {error && <ErrorText>{error}</ErrorText>}
    </Field>
    <p>Подтверждаете дату установки оборудования?</p>
  </PopconfirmTitleWrapper>;














const initialState = {
  installDate: moment().toISOString(),
  visible: false,
  errors: {}
};

export default class AddEquipmentButton extends Component {
  state = initialState;

  static defaultProps = {
    disableDate: true
  };

  confirm = () => {
    if (this.state.installDate && moment(this.state.installDate).isValid()) {
      this.props.onConfirm(this.state.installDate);
      this.setState(initialState);
    } else {
      this.setState({
        errors: {
          installDate: 'Неверная дата установки оборудования'
        }
      });
    }
  };

  showPopover = () =>
  this.setState({
    visible: true
  });

  hidePopover = () => this.setState(initialState);

  render() {
    const { installDate, visible, errors } = this.state;
    const { disabled, disableDate } = this.props;
    return (
      <Popconfirm
        icon={null}
        title={
        <PopconfirmTitle
          disableDate={disableDate}
          onChange={(value, dateString) =>
          this.setState({
            installDate: convertDateToString(value, dateString)
          })
          }
          dateInstall={installDate}
          error={errors.installDate} />

        }
        visible={visible}
        okText="Да"
        placement="topLeft"
        cancelText="Нет"
        onConfirm={this.confirm}
        onCancel={this.hidePopover}
        overlayClassName="without-icon">

        <Button onClick={this.showPopover} type="primary" disabled={disabled}>
          Добавить
        </Button>
      </Popconfirm>);

  }
}
